import { uniqBy } from 'lodash';
import { DeviceStatusAirConnectAPIResponse } from '../deviceStatus.model';

function getGatewayOffline(
  data: DeviceStatusAirConnectAPIResponse[] | undefined
) {
  return (
    data &&
    uniqBy(
      data
        ?.filter((item) => item.nodeID === 31)
        .filter((item) => item.lastResponseState !== 'GATEWAY_OK'),
      'deviceID'
    )
  );
}

export default getGatewayOffline;
